import { Navigate, Outlet, Route, Routes } from "react-router";
import Layout from "../layout/Layout";
import { routes } from "../routes/routes";
import { useEffect } from "react";
import Login from "./auth/Login";
import PdfAndPrint from "../components/common/print-and-print/PdfAndPrint";
import MultiPrint2 from "../components/common/multi-print/MultiPrint2";

import useNavigationScroll from "../hooks/useNavigationScroll";
import { AccessRoute, AdminAccessProvider } from "../layout/access/AdminAccessContext";

const PrivateRoute = ({ component }) => {
  const isAuthenticated = localStorage.getItem("liResponse");
  return isAuthenticated === "1" ? component : <Navigate to="/login" />;
};

export default function Candle() {
  useNavigationScroll();
  function processThemeChange() {
    const theme = localStorage.getItem("color-theme");
    if (theme) {
      if (theme === "dark") {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      }
    } else {
      if (document.documentElement.classList.contains("dark")) {
        console.log(document.documentElement.classList.contains("dark"));
        // document.documentElement.classList.remove('dark');
        localStorage.setItem("color-theme", "dark");
      } else {
        // document.documentElement.classList.add('light');
        localStorage.setItem("color-theme", "light");
      }
    }
  }

  useEffect(() => {
    processThemeChange();
  }, []);

  return (
    <Routes>
      <Route exact path="/login" element={<Login />} />
      <Route element={<PrivateRoute component={<AdminAccessProvider><Outlet /></AdminAccessProvider>} />}>
        <Route exact path="/pdf-and-print" element={<AccessRoute><PdfAndPrint /></AccessRoute>} />
        <Route exact path="/multi-print" element={<AccessRoute><MultiPrint2 /></AccessRoute>} />
        <Route exact path="/" element={<Layout />}>
          {routes?.map((item) => {
            return (
              <Route
                key={item.path}
                path={item.path}
                element={<AccessRoute>{item.component}</AccessRoute>}
              />
            );
          })}
        </Route>
      </Route>
    </Routes>
  );
}
